import { useQuery } from '@tanstack/react-query';
import { IGlobalMail } from '../../Interfaces/IGlobalMail';
import { customFetcher } from '../useFetch';

export const useGetGlobalMails = () => {
  const { data: globalMails, isLoading: isLoadingGlobalMails } = useQuery<
    IGlobalMail[]
  >({
    queryKey: ['globalmail'],
    queryFn: () => customFetcher({ endpoint: '/globalmail' }),
  });

  return { globalMails, isLoadingGlobalMails };
};
